/* AWYKN theme script. Vanilla, no dependencies. Every module guards on the
   presence of its markup, so any page can load the whole file safely. Ported
   from the React components of the original storefront (SiteChrome,
   CartProvider/CartDrawer, ProductBuyBox, ProductMedia, QuickAdd, Faq, FitNotes). */
(function () {
  "use strict";

  var CONFIG = window.AWYKN || { routes: {}, strings: {} };
  var STR = CONFIG.strings || {};
  var reduceMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var FOCUSABLE = 'button:not([disabled]), a[href], input:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function announce(text) {
    var region = $("[data-live-region]");
    if (!region) return;
    region.textContent = "";
    window.setTimeout(function () { region.textContent = text; }, 30);
  }
  function formatMoney(cents) {
    var format = CONFIG.moneyFormat || "${{amount}}";
    var amount = (cents / 100).toFixed(2);
    var noDecimals = Math.round(cents / 100).toString();
    var withCommaDecimal = amount.replace(".", ",");
    var thousands = function (value, sep, dec) {
      var parts = value.split(dec);
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, sep);
      return parts.join(dec);
    };
    return format
      .replace(/\{\{\s*amount\s*\}\}/g, thousands(amount, ",", "."))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, thousands(noDecimals, ",", "."))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, thousands(withCommaDecimal, ".", ","))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, thousands(noDecimals, ".", ","))
      .replace(/\{\{\s*amount_with_space_separator\s*\}\}/g, thousands(withCommaDecimal, " ", ","))
      .replace(/\{\{\s*amount_no_decimals_with_space_separator\s*\}\}/g, thousands(noDecimals, " ", ","))
      .replace(/\{\{\s*amount_with_apostrophe_separator\s*\}\}/g, thousands(amount, "'", "."));
  }

  /* ---------- Focus trap + scroll lock shared by the drawer and the modal ---------- */
  function makeDialog(root, panel, opts) {
    var previouslyFocused = null;
    var previousOverflow = "";
    var open = false;

    function onKeyDown(event) {
      if (event.key === "Escape") { close(); return; }
      if (event.key !== "Tab") return;
      var focusable = $$(FOCUSABLE, panel);
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    }

    function show() {
      if (open) return;
      open = true;
      previouslyFocused = document.activeElement;
      previousOverflow = document.body.style.overflow;
      document.body.style.overflow = "hidden";
      root.hidden = false;
      /* Force a style flush so the transition runs from the hidden state. */
      void root.offsetWidth;
      root.setAttribute("data-open", "true");
      document.addEventListener("keydown", onKeyDown);
      var target = opts && opts.initialFocus ? $(opts.initialFocus, panel) : null;
      window.setTimeout(function () { (target || panel).focus({ preventScroll: true }); }, 40);
      if (opts && opts.onOpen) opts.onOpen();
    }

    function close() {
      if (!open) return;
      open = false;
      root.setAttribute("data-open", "false");
      document.removeEventListener("keydown", onKeyDown);
      document.body.style.overflow = previousOverflow;
      var done = function () { if (!open) root.hidden = true; };
      if (reduceMotion) done(); else window.setTimeout(done, 420);
      if (previouslyFocused && previouslyFocused.focus) previouslyFocused.focus({ preventScroll: true });
      if (opts && opts.onClose) opts.onClose();
    }

    return { open: show, close: close, isOpen: function () { return open; } };
  }

  /* ---------- Header: mobile menu ---------- */
  function initHeader() {
    $$("[data-header]").forEach(function (header) {
      var toggle = $("[data-menu-toggle]", header);
      var nav = $("[data-nav]", header);
      if (!toggle || !nav) return;
      var bar = $("span", toggle);
      function setOpen(open) {
        nav.setAttribute("data-open", String(open));
        toggle.setAttribute("aria-expanded", String(open));
        toggle.setAttribute("aria-label", open ? toggle.getAttribute("data-label-close") : toggle.getAttribute("data-label-open"));
        if (bar) bar.setAttribute("data-open", String(open));
      }
      toggle.addEventListener("click", function () { setOpen(nav.getAttribute("data-open") !== "true"); });
      $$("a", nav).forEach(function (link) { link.addEventListener("click", function () { setOpen(false); }); });
      document.addEventListener("keydown", function (event) { if (event.key === "Escape") setOpen(false); });
    });
  }

  /* ---------- Cart: drawer, page, AJAX changes ---------- */
  var cart = (function () {
    var root = $("[data-cart-drawer]");
    var panel = root ? $("[data-cart-panel]", root) : null;
    var dialog = root && panel ? makeDialog(root, panel, { initialFocus: "[data-cart-focus]" }) : null;

    function bodies() { return $$("[data-cart-body]"); }

    function setCount(count) {
      $$("[data-cart-count]").forEach(function (el) { el.textContent = count; });
      $$("[data-cart-open], a.bagButton").forEach(function (el) {
        var label = el.getAttribute("aria-label");
        if (label) el.setAttribute("aria-label", label.replace(/\d+/, count));
      });
    }

    /* Re-render the cart body from the section markup Shopify returns. */
    function refresh(sectionsHtml) {
      var targets = bodies();
      if (!targets.length) return;
      var parser = new DOMParser();
      function apply(html) {
        var doc = parser.parseFromString(html, "text/html");
        var candidates = $$("[data-cart-body]", doc);
        if (!candidates.length) return;
        targets.forEach(function (target) {
          /* The drawer and the page render the same snippet with different
             empty-state buttons, so each body declares which context it was
             rendered for. Match on that rather than on DOM ancestry: the
             Section Rendering API returns the section on its own, without the
             drawer wrapper around it. */
          var context = target.getAttribute("data-cart-context");
          var fresh = candidates.filter(function (node) {
            return node.getAttribute("data-cart-context") === context;
          })[0] || candidates[0];
          target.innerHTML = fresh.innerHTML;
          target.setAttribute("data-item-count", fresh.getAttribute("data-item-count") || "0");
          bindBody(target);

        });
      }
      if (sectionsHtml) { apply(sectionsHtml); return Promise.resolve(); }
      var sectionId = root ? "cart-drawer" : "main-cart";
      return fetch(window.location.pathname + "?sections=" + sectionId, { headers: { Accept: "application/json" } })
        .then(function (r) { return r.json(); })
        .then(function (json) { apply(json[sectionId] || ""); });
    }

    function change(line, quantity) {
      return fetch(CONFIG.routes.cartChange || "/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ line: line, quantity: quantity, sections: root ? "cart-drawer" : "main-cart" }),
      })
        .then(function (r) { if (!r.ok) throw new Error("cart"); return r.json(); })
        .then(function (json) {
          setCount(json.item_count);
          var html = json.sections ? (json.sections["cart-drawer"] || json.sections["main-cart"]) : null;
          return refresh(html);
        })
        .catch(function () { announce(STR.cartError || "Cart error"); });
    }

    function add(variantId, quantity) {
      return fetch(CONFIG.routes.cartAdd || "/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ items: [{ id: variantId, quantity: quantity || 1 }], sections: root ? "cart-drawer" : "" }),
      }).then(function (r) {
        return r.json().then(function (json) {
          if (!r.ok) throw new Error(json.description || json.message || "cart");
          var html = json.sections ? json.sections["cart-drawer"] : null;
          return fetch("/cart.js").then(function (c) { return c.json(); }).then(function (state) {
            setCount(state.item_count);
            return refresh(html);
          });
        });
      });
    }

    /* Delegated from the body element rather than bound per button: the line
       markup is replaced wholesale on every cart change, so handlers attached
       to the old buttons would be thrown away with them. */
    function bindBody(body) {
      if (body.__awyknBound) return;
      body.__awyknBound = true;

      body.addEventListener("click", function (event) {
        var target = event.target;

        var close = target.closest ? target.closest("[data-cart-close]") : null;
        if (close && body.contains(close)) { if (dialog) dialog.close(); return; }

        var button = target.closest ? target.closest("[data-line-dec], [data-line-inc], [data-line-remove]") : null;
        if (!button || !body.contains(button)) return;
        var lineEl = button.closest("[data-line-key]");
        if (!lineEl) return;
        var line = Number(lineEl.getAttribute("data-line-index"));
        var qtyEl = $("[data-line-qty]", lineEl);
        var qty = qtyEl ? Number(qtyEl.textContent) : 1;
        var next = button.hasAttribute("data-line-remove") ? 0 : button.hasAttribute("data-line-inc") ? Math.min(20, qty + 1) : qty - 1;
        lineEl.setAttribute("aria-busy", "true");
        change(line, next);
      });

      body.addEventListener("submit", function (event) {
        var form = event.target.closest ? event.target.closest("[data-checkout-form]") : null;
        if (!form) return;
        var button = $("[data-checkout-button]", form);
        var label = $("[data-checkout-label]", form);
        if (button) button.setAttribute("aria-disabled", "true");
        if (label && button) label.textContent = button.getAttribute("data-loading-label") || label.textContent;
      });
    }

    function open() {
      if (dialog) dialog.open();
      else window.location.assign(CONFIG.routes.cart || "/cart");
    }

    if (root) {
      $$("[data-cart-close]", root).forEach(function (button) {
        if (!button.closest("[data-cart-body]")) button.addEventListener("click", function () { dialog.close(); });
      });
    }
    $$("[data-cart-open]").forEach(function (button) { button.addEventListener("click", open); });
    bodies().forEach(bindBody);

    return { open: open, add: add, refresh: refresh };
  })();

  /* ---------- Product media: front/back toggle (cards and product page) ---------- */
  function initViewToggles(scope) {
    $$("[data-view-toggle]", scope).forEach(function (toggle) {
      if (toggle.__awykn) return;
      toggle.__awykn = true;
      var wrap = toggle.closest("[data-product-card], [data-media-root], .visualPanel") || toggle.parentElement;
      var mediaRoot = $("[data-media-root]", wrap) || wrap;
      function frames() { return $$(".mediaTransition", mediaRoot); }
      function show(view) {
        var current = frames().filter(function (f) { return !f.hidden; })[0];
        var next = frames().filter(function (f) { return (f.getAttribute("data-media-view") || f.getAttribute("data-media-index")) === String(view); })[0];
        if (!next || next === current) return;
        $$("button", toggle).forEach(function (b) { b.setAttribute("aria-pressed", String(b.getAttribute("data-view") === String(view))); });
        var swap = function () {
          if (current) { current.hidden = true; current.classList.remove("is-leaving"); }
          next.hidden = false;
          next.classList.add("is-entering");
          next.addEventListener("animationend", function () { next.classList.remove("is-entering"); }, { once: true });
        };
        if (current && !reduceMotion) {
          current.classList.add("is-leaving");
          current.addEventListener("animationend", swap, { once: true });
          window.setTimeout(function () { if (current.classList.contains("is-leaving")) swap(); }, 260);
        } else swap();
      }
      $$("button", toggle).forEach(function (button) {
        button.addEventListener("click", function (event) {
          event.preventDefault();
          event.stopPropagation();
          show(button.getAttribute("data-view"));
        });
      });
    });
  }

  /* ---------- Quick add on showcase cards ---------- */
  function initQuickAdd(scope) {
    $$("[data-quick-add]", scope).forEach(function (rootEl) {
      if (rootEl.__awykn) return;
      rootEl.__awykn = true;
      var trigger = $("[data-quick-add-trigger]", rootEl);
      var sizes = $("[data-quick-add-sizes]", rootEl);
      if (!trigger || !sizes) return;
      function setOpen(open) {
        rootEl.setAttribute("data-open", String(open));
        trigger.setAttribute("aria-expanded", String(open));
        trigger.hidden = open;
        sizes.hidden = !open;
        if (open) {
          document.addEventListener("pointerdown", onPointer);
          document.addEventListener("keydown", onKey);
          var first = $("button:not([disabled])", sizes);
          if (first) first.focus({ preventScroll: true });
        } else {
          document.removeEventListener("pointerdown", onPointer);
          document.removeEventListener("keydown", onKey);
        }
      }
      function onPointer(event) { if (!rootEl.contains(event.target)) setOpen(false); }
      function onKey(event) { if (event.key === "Escape") { setOpen(false); trigger.focus(); } }
      trigger.addEventListener("click", function () { setOpen(true); });
      $$("button[data-variant-id]", sizes).forEach(function (button) {
        button.addEventListener("click", function () {
          if (button.disabled) return;
          rootEl.setAttribute("aria-busy", "true");
          /* Pass the id through as written. Liquid emits a numeric variant id,
             but coercing here would turn any other id form into NaN. */
          cart.add(button.getAttribute("data-variant-id"), 1)
            .then(function () {
              setOpen(false);
              if (CONFIG.openOnAdd !== false) cart.open();
            })
            .catch(function (error) { announce(error.message || STR.cartError); })
            .then(function () { rootEl.removeAttribute("aria-busy"); });
        });
      });
    });
  }

  /* ---------- Product form ---------- */
  function initProduct(scope) {
    $$("[data-product-section]", scope).forEach(function (section) {
      if (section.__awykn) return;
      section.__awykn = true;
      var form = $("[data-product-form]", section);
      var dataEl = $("[data-product-json]", section);
      var configEl = $("[data-product-config]", section);
      if (!form || !dataEl) return;
      var product = JSON.parse(dataEl.textContent);
      var config = configEl ? JSON.parse(configEl.textContent) : {};
      var variantInput = $("[data-variant-id]", form);
      var priceEl = $("[data-price]", form);
      var addButton = $("[data-add-button]", form);
      var addLabel = $("[data-add-label]", form);
      var burst = $("[data-burst]", form);
      var validation = $("[data-validation]", form);
      var qtyInput = $("[data-qty-input]", form);
      var qtyValue = $("[data-qty-value]", form);
      var groups = $$("[data-option-index]", form);

      /* selected[i] is the chosen value for option i, or null while the size
         is still unpicked - the original site never preselects a size. */
      var selected = groups.map(function (group) {
        var pressed = $('[aria-pressed="true"]', group);
        return pressed ? pressed.getAttribute("data-option-value") : null;
      });
      if (config.selectedVariant) {
        var initial = product.variants.filter(function (v) { return v.id === config.selectedVariant; })[0];
        if (initial) selected = initial.options.slice();
      }

      function variantFor(options) {
        return product.variants.filter(function (v) {
          return v.options.every(function (value, i) { return options[i] == null || options[i] === value; });
        });
      }
      function currentVariant() {
        if (selected.some(function (v) { return v == null; })) return null;
        return variantFor(selected)[0] || null;
      }

      function render() {
        groups.forEach(function (group, i) {
          var kind = group.getAttribute("data-option-kind");
          $$("[data-option-value]", group).forEach(function (button) {
            var value = button.getAttribute("data-option-value");
            button.setAttribute("aria-pressed", String(selected[i] === value));
            if (kind === "color") return;
            /* A value is sold out when no variant with the other chosen
               options and this value is available. */
            var probe = selected.slice(); probe[i] = value;
            var matches = variantFor(probe);
            var soldOut = matches.length === 0 || !matches.some(function (v) { return v.available; });
            button.disabled = soldOut;
            button.setAttribute("aria-label", soldOut ? value + " — " + (STR.soldOut || "sold out").toLowerCase() : value);
          });
          if (kind === "color") {
            var label = $("[data-option-label]", group);
            if (label && selected[i]) label.textContent = selected[i] + (label.textContent.indexOf("·") > -1 ? label.textContent.slice(label.textContent.indexOf(" ·")) : "");
          }
        });
        var variant = currentVariant();
        variantInput.value = variant ? variant.id : "";
        if (variant && priceEl) {
          priceEl.innerHTML = formatMoney(variant.price) + (variant.compare_at_price > variant.price ? ' <s class="comparePrice">' + formatMoney(variant.compare_at_price) + "</s>" : "");
        }
        if (addButton && addLabel) {
          if (variant && !variant.available) { addButton.disabled = true; addLabel.textContent = STR.soldOut || "Sold out"; }
          else { addButton.disabled = false; addLabel.textContent = STR.addToCart || "Add to bag"; }
        }
        if (variant && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set("variant", variant.id);
          window.history.replaceState({}, "", url.toString());
        }
        var color = groups.map(function (g, i) { return g.getAttribute("data-option-kind") === "color" ? selected[i] : null; }).filter(Boolean)[0];
        if (color) section.setAttribute("data-color", color);
      }

      groups.forEach(function (group, i) {
        $$("[data-option-value]", group).forEach(function (button) {
          button.addEventListener("click", function () {
            selected[i] = button.getAttribute("data-option-value");
            if (validation) validation.hidden = true;
            render();
          });
        });
      });

      var dec = $("[data-qty-dec]", form), inc = $("[data-qty-inc]", form);
      function setQty(n) { n = Math.max(1, Math.min(20, n)); if (qtyInput) qtyInput.value = n; if (qtyValue) qtyValue.textContent = n; }
      if (dec) dec.addEventListener("click", function () { setQty(Number(qtyInput.value) - 1); });
      if (inc) inc.addEventListener("click", function () { setQty(Number(qtyInput.value) + 1); });

      function fail(message, spoken) {
        if (validation) { validation.textContent = "↳ " + message; validation.hidden = false; }
        announce(spoken || message);
      }

      form.addEventListener("submit", function (event) {
        event.preventDefault();
        var variant = currentVariant();
        if (!variant) { fail(STR.chooseSize || "Choose a size.", STR.chooseSizeShort); return; }
        if (!variant.available) { fail(STR.sizeSoldOut || "Sold out."); return; }
        var qty = Number(qtyInput ? qtyInput.value : 1);
        addButton.setAttribute("aria-busy", "true");
        cart.add(variant.id, qty)
          .then(function () {
            if (validation) validation.hidden = true;
            announce((STR.added || "{{ quantity }} {{ title }} added.").replace("{{ quantity }}", qty).replace("{{ title }}", product.title));
            if (burst && !reduceMotion) {
              burst.hidden = false;
              burst.classList.remove("is-bursting");
              void burst.offsetWidth;
              burst.classList.add("is-bursting");
              window.setTimeout(function () { burst.hidden = true; }, 700);
            }
            if (CONFIG.openOnAdd !== false) cart.open();
          })
          .catch(function (error) { fail(error.message || STR.cartError); })
          .then(function () { addButton.removeAttribute("aria-busy"); });
      });

      render();

      /* Fit notes modal */
      var fitRoot = $("[data-fit-root]", section.parentElement) || $("[data-fit-root]");
      if (fitRoot) {
        var fitPanel = $("[data-fit-panel]", fitRoot);
        var fitDialog = makeDialog(fitRoot, fitPanel, { initialFocus: ".closeButton" });
        $$("[data-fit-open]", section).forEach(function (b) { b.addEventListener("click", fitDialog.open); });
        $$("[data-fit-close]", fitRoot).forEach(function (b) { b.addEventListener("click", fitDialog.close); });
      }
    });
  }

  /* ---------- FAQ accordion ---------- */
  function initFaq(scope) {
    $$("[data-faq]", scope).forEach(function (faq) {
      if (faq.__awykn) return;
      faq.__awykn = true;
      var items = $$("[data-faq-item]", faq);
      function setOpen(item, open) {
        var trigger = $("[data-faq-trigger]", item);
        var panel = $("[data-faq-panel]", item);
        var bubble = $(".faqBubble", item);
        var toggle = $(".faqToggle", item);
        trigger.setAttribute("aria-expanded", String(open));
        if (toggle) toggle.textContent = open ? "−" : "+";
        if (bubble) { if (open) bubble.setAttribute("data-open", ""); else bubble.removeAttribute("data-open"); }
        if (open) {
          panel.hidden = false;
          void panel.offsetWidth;
          panel.setAttribute("data-open", "true");
        } else {
          panel.setAttribute("data-open", "false");
          var hide = function () { if (panel.getAttribute("data-open") === "false") panel.hidden = true; };
          if (reduceMotion) hide(); else window.setTimeout(hide, 340);
        }
      }
      items.forEach(function (item) {
        $("[data-faq-trigger]", item).addEventListener("click", function () {
          var isOpen = $("[data-faq-trigger]", item).getAttribute("aria-expanded") === "true";
          items.forEach(function (other) { if (other !== item && $("[data-faq-trigger]", other).getAttribute("aria-expanded") === "true") setOpen(other, false); });
          setOpen(item, !isOpen);
        });
      });
    });
  }

  /* ---------- Product recommendations (lazy, via Section Rendering API) ---------- */
  function initRecommendations(scope) {
    $$("[data-product-recommendations]", scope).forEach(function (el) {
      if (el.__awykn || !el.getAttribute("data-url")) return;
      el.__awykn = true;
      fetch(el.getAttribute("data-url")).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, "text/html");
        var fresh = $("[data-product-recommendations]", doc);
        if (fresh && fresh.innerHTML.trim()) { el.innerHTML = fresh.innerHTML; initAll(el); }
      }).catch(function () {});
    });
  }

  function initAll(scope) {
    initViewToggles(scope);
    initQuickAdd(scope);
    initProduct(scope);
    initFaq(scope);
    initRecommendations(scope);
  }

  document.addEventListener("DOMContentLoaded", function () {
    initHeader();
    initAll(document);
    document.documentElement.classList.add("js-ready");
  });

  /* Theme editor: re-bind when a section is added or reloaded. */
  document.addEventListener("shopify:section:load", function (event) {
    initHeader();
    initAll(event.target);
  });
  document.addEventListener("shopify:section:select", function (event) {
    if (event.target.querySelector("[data-cart-drawer]")) cart.open();
  });
  document.addEventListener("shopify:section:deselect", function (event) {
    if (event.target.querySelector("[data-cart-drawer]")) {
      var root = event.target.querySelector("[data-cart-drawer]");
      if (root) { root.setAttribute("data-open", "false"); root.hidden = true; document.body.style.overflow = ""; }
    }
  });
})();
